import { Switch } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '@/api/errors';
import { setObjectInternal, type DataObject } from '@/api/objects';

/** Staff only: the object's `internal` mark (AN17) — a client then neither lists nor opens it. */
export function InternalSwitch({ object }: { object: DataObject }) {
  const { t } = useTranslation('projects');
  const qc = useQueryClient();
  const id = object.public_id;
  const setInternal = useMutation({
    mutationFn: (internal: boolean) => setObjectInternal(id, internal),
    onSuccess: (o) => {
      qc.setQueryData(['object', id], o);
      for (const key of ['objects', 'analysis', 'analyses', 'audit']) void qc.invalidateQueries({ queryKey: [key] });
    },
  });
  return (
    <Switch
      label={t('staff.internal')}
      description={t('staff.internalHint')}
      checked={!!object.internal}
      disabled={!!object.deleted || setInternal.isPending}
      onChange={(e) => {
        setInternal.mutate(e.currentTarget.checked, {
          onError: (err) => notifications.show({ color: 'red', message: errorMessage(err) }),
        });
      }}
    />
  );
}
